import { FastField } from "formik";
import BaseInput from './BaseInput';

const Input = ({...props}) => {

    return (
        <FastField name={props.name}>
            {({ field, meta }) => (
                <BaseInput  {...{field, meta, props}}/>
            )}
        </FastField>
    );
};

export default Input;